<template>
    <div>
        <div class="row mx-2 custom-font-size">
            <div class="col-12 ">

                <VueEditor  v-model="content"/>


                <!-- <div class="row">
                    <label>آدرس</label>
                    <textarea class="form-control" rows="3"></textarea>
                </div>
                <div class="row mt-2">
                    <label>شماره تماس</label>
                    <textarea class="form-control" rows="3"></textarea>
                </div>
                <div class="row mt-2">
                    <label>ایمیل</label>
                    <textarea class="form-control" rows="1" dir="ltr"></textarea>
                </div>
                <div class="row mt-2">
                    <label>فکس</label>
                    <textarea class="form-control" rows="1"></textarea>
                </div>
                <div class="row mt-2">
                    <label>توضیحات</label>
                    <textarea class="form-control" rows="3"></textarea>
                </div> -->
            </div>
        </div>
        <div class="d-flex justify-content-center mt-3">
            <button class="btn btn-success w-25" @click="submit()">ثبت</button>
        </div>
    </div>
</template>


<script>
import { VueEditor } from "vue2-editor";
export default {
    components: { VueEditor },
    data() {
        
        return{
            content: ""
        }
    },
    created(){
        this.getAboutUs()
    },
    methods:{
        submit(){
          
            this.$PostData_new('WebSiteSetting/AddAboutUs/', 'post', {aboutUs:this.content}).then((resp)=>{
                if(resp.isSuccess == true){
                    this.$mySweetDefaultTost('عملیات موفق', resp.message, 'success', 2000)
                }else{
                    this.$mySweetDefaultTost('عملیات ناموفق', resp.message, 'error', 2000)
                }
            }).catch((err)=>{
                this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
                console.error(err)
            })
        },
        getAboutUs(){
            this.$PostData_new('WebSiteSetting/GetAboutUs', 'get').then((resp)=>{
                this.content = resp
            }).catch((err)=>{
                this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
                console.error(err)
            })
        }
    }
}
</script>


<style scoped>
textarea {
    resize: none;
}
</style>